export const createLog = async (originalItem, modifiedItem, actiontype, pdf, store) => {
  //console.log('ORIG ', originalItem, ' MODIF ', modifiedItem, 'ACTION ', actiontype)
  let logObject = {id: 0, itemid: 0, actiontype: '', originalparameter: '', modifiedparameter: '', timestamp: new Date(), pdf: ''}
  
  if(actiontype === 'SAVE'){
    logObject.actiontype = actiontype;
    logObject.pdf = pdf;
    logObject.itemid = modifiedItem.id;
    if(originalItem.type === 'IT'){
      logObject.modifiedparameter = originalItem.category + ' --- ' + originalItem.sn + ' --- ' + originalItem.barcode; 
    }else if(originalItem.type === 'FURNITURE'){
      logObject.modifiedparameter = originalItem.brand + ' --- ' + originalItem.barcode; 
    }
  }else if(actiontype === 'MODIFY'){
    logObject.itemid = originalItem.id;
    logObject.actiontype = actiontype;
    logObject.pdf = pdf;
    Object.entries(originalItem).forEach(([key, value]) => {
      if(value !== modifiedItem[key]){
        logObject.originalparameter = logObject.originalparameter.concat(`${key}: ` + originalItem[key] + ' --- '); 
        logObject.modifiedparameter = logObject.modifiedparameter.concat(`${key}: ` + modifiedItem[key])
      } 
    })
    }else if(actiontype === 'PASS') {
    logObject.itemid = originalItem.id;
    logObject.actiontype = actiontype;
    logObject.pdf = pdf;
    if(originalItem.type === 'IT'){
      let orig = await store.datas.findOne('USERS', 'id', originalItem.userid)
      let mod = await store.datas.findOne('USERS', 'id', modifiedItem.userid)
      logObject.originalparameter = orig.email
      logObject.modifiedparameter = mod.email
    }else{
      let orig = await store.datas.findOne('CITIES', 'officeid', originalItem.officeid)
      let mod = await store.datas.findOne('CITIES', 'officeid', modifiedItem.officeid)
      console.log('LOG' , orig, modifiedItem)
      logObject.originalparameter = orig.name
      logObject.modifiedparameter = mod.name
    }
  }else if(actiontype === 'LELTAR') {
      logObject.itemid = modifiedItem.id
      logObject.timestamp = new Date();
      logObject.originalparameter = `LELTÁRSTÁTUSZ -> ${originalItem.leltar}`;
      logObject.modifiedparameter = `LELTÁRSTÁTUSZ -> ${modifiedItem.leltar}`;
      logObject.pdf = 'NOPDF'
  }
  {
    logObject.actiontype = actiontype;

  }
  return logObject
}


